import { URLS } from 'api/constants';
import { IComplaint, IComplaintResult } from 'constants/types';
import { apiGet, apiGetSafe } from './client';
import { PaginationRequest, PaginationResponse } from './types';

type ApiParams = Record<string, string | number | boolean | undefined | null>;

export async function getComplaintById(id?: string) {
  return apiGetSafe<IComplaint>(`${URLS.COMPLAINTS}${id ?? ''}`);
}

export async function getComplaintsByCasinoId(id: string) {
  return apiGet<IComplaintResult>(`${URLS.COMPLAINTS_BY_CASINO}${id}`);
}

export async function getComplaintsByParentId(parentId?: string) {
  return apiGet<IComplaintResult>(URLS.COMPLAINTS, {
    parent_id: parentId,
    limit: 100,
  });
}

export async function listComplaints(params: PaginationRequest = {}) {
  return apiGet<PaginationResponse<IComplaint>>(
    URLS.COMPLAINTS,
    params as ApiParams
  );
}
